<template>
  <div v-if="kbxmlc">
    <div :class="['box', kbxmlc.zt == '2' || role != 'Z' ? 'noBtn' : '']">
      <div class="clear">
        <p class="cont-title lf">资格符合性审查</p>
        <div class="rt">
          <el-input
            v-model="tbdwmc"
            class="input-with-select lf"
            style="width: 250px; margin: 0 10px"
            placeholder="投标单位名称"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="serachData"
            ></el-button>
          </el-input>
          <el-button type="primary" @click="lookRules" :disabled="waitLoading"
            >查看规则</el-button
          >
          <el-button type="primary" @click="lookJjgg" :disabled="waitLoading"
            >查看竞价公告</el-button
          >
          <el-button
            type="primary"
            @click="oneKeyExam"
            :disabled="waitLoading || kbxmlc.zt == '2'"
            v-if="role == 'Z'"
            >一键审查</el-button
          >
          <el-button
            v-if="role != 'B'"
            type="primary"
            @click="lookQyzz"
            :disabled="waitLoading"
            >查看企业资质</el-button
          >
        </div>
      </div>
      <div class="red" style="padding-bottom: 10px">
        <div v-for="(item, index) in parameterExtractionResults" :key="index">
          <span style="margin-right: 30px"
            >{{ item.parameter }}{{ item.value }}{{ item.unit }}</span
          >
        </div>
      </div>
      <div style="height: 100%; overflow: auto">
        <el-table
          ref="table"
          border
          :data="tableData"
          style="width: 100%"
          v-loading="waitLoading"
        >
          <el-table-column type="index" label="序号" width="60">
            <template slot-scope="scope">{{
              (currentPage - 1) * pageSize + scope.$index + 1
            }}</template>
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="投标单位名称"
            show-overflow-tooltip
            min-width="200"
          ></el-table-column>
          <el-table-column
            prop="tenderQuotation"
            :label="`投标报价(${unit})`"
            show-overflow-tooltip
            width="150"
            ><template slot-scope="scope"
              >{{ scope.row.tenderQuotation }}</template
            ></el-table-column
          >
          <el-table-column
            v-for="item in exhibitionList"
            :key="item.prop"
            :label="item.mc"
            :prop="item.prop"
          ></el-table-column>
          <el-table-column
            prop="complianceReview"
            label="符合性审查"
            width="120"
          >
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.complianceReview"
                v-if="kbxmlc.zt != '2' && role == 'Z'"
                class="small"
                @change="saveComplianceReview(scope.row)"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
              <template v-else>{{
                scope.row.complianceReview == 1
                  ? "通过"
                  : scope.row.complianceReview == 2
                  ? "不通过"
                  : ""
              }}</template>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" v-if="hasTenderFile && role != 'B'">
            <template slot-scope="scope">
              <el-button type="text" @click="watchFile(scope.row)"
                >查看投标文件</el-button
              >
              <el-button type="text" @click="downLoadFile(scope.row)"
                >下载</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="bz"
            label="备注"
            show-overflow-tooltip
            width="200"
          ></el-table-column>
        </el-table>
        <div class="clear">
          <pagination
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @changePage="changePage"
          >
          </pagination>
        </div>
      </div>

      <el-button
        v-if="!isTbr && kbxmlc.zt != '2'"
        type="primary lcNext"
        :disabled="waitLoading"
        @click="nextBtn"
        >下一步</el-button
      >
    </div>

    <!-- 添加投标单位弹窗 -->
    <el-dialog
      title="查看规则"
      :visible.sync="showRules"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="rules">
        <p v-for="(item, index) in rules" :key="index">{{ item }}</p>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="showRules = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="备注"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-input v-model="complianceReview.bz"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitRemark">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
export default {
  name: "zgfhxsc", //开评一体资格符合性审查
  components: {
    Pagination,
  },
  data() {
    return {
      waitLoading: false,
      kbxmlc: {},
      djlcId: "", //当前节点状态
      d: null,
      adjustmentCoefficient: null,
      parameterExtractionResults: [],
      tableData: [],
      exhibitionList: [],
      newOrOld: "0",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      options: [
        { label: "通过", id: "1" },
        { label: "不通过", id: "2" },
      ],
      tbdwmc: "",
      isOk: false,
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      showRules: false,
      rules: [],
      unit: "",
      complianceReview: {},
      dialogVisible: false,
      hasTenderFile: false,
    };
  },
  computed: {
    // 是否展示计算得分按钮
    isShowScore() {
      return this.kbxmlc.zt !== "2" && ["T", "A", "Z"].includes(this.role);
    },
    // 是否展示一键不通过按钮
    isShowNoPass() {
      return (
        this.kbxmlc.zt !== "2" &&
        ["T", "A", "Z"].includes(this.role) &&
        this.newOrOld === "1"
      );
    },
    isTbr() {
      return ["B"].includes(this.role);
    }
  },
  methods: {
    lookQyzz(e) {
      console.log(e);
      console.log(process.env.NODE_ENV);
      // if(process.env.NODE_ENV == 'development'){
      //   window.open(`http://192.168.1.70:30001/qualifications?sectionId=${this.kbxmlc.bdId}`, "_blank");
      // }else{
      //   window.open(`https://lxtrade.zhaotx.cn/qualifications?sectionId=${this.kbxmlc.bdId}`, "_blank");
      // }
      window.open(
        `https://pjtrade.zhaotx.cn/qualifications?sectionId=${this.kbxmlc.bdId}`,
        "_blank"
      );
    },
    watchFile(rowData) {
      window.open(
        `/tbwjFile?bdId=${this.kbxmlc.bdId}&id=${rowData.id}`,
        "_blank"
      );
    },
    async downLoadFile(rowData) {
      window.open(rowData.fileUrl,"_blank");
      // this.waitLoading = true;
      // try {
      //   let res = await this.$api.tenderFileDownload(rowData.id);
      //   let fileName = decodeURI(
      //     res.headers["content-disposition"].split("=")[1]
      //   );
      //   let blob = new Blob([res.data]);
      //   if (window.navigator.msSaveOrOpenBlob) {
      //     navigator.msSaveBlob(blob, fileName);
      //   } else {
      //     var link = document.createElement("a");
      //     link.href = window.URL.createObjectURL(blob);
      //     link.download = fileName;
      //     link.click();
      //     //释放内存
      //     window.URL.revokeObjectURL(link.href);
      //   }
      //   this.waitLoading = false;
      // } catch (error) {
      //   this.$message({
      //     type: "warning",
      //     message: "下载失败",
      //   });
      //   this.waitLoading = false;
      // }
    },
    //一键审查
    async oneKeyExam() {
      let para = { djlcId: this.djlcId };
      try {
        let res = await this.$api.postInitializeZgsc(para);
        if (res.status == 200) {
          this.$message({ type: "success", message: "操作成功！" });
          this.getData();
          let obj = {
            lx: "zb",
            data: {
              id: "",
            },
          };
          this.$emit("send", JSON.stringify(obj));
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //开评一体
    async lookRules() {
      let para = { kbxmId: this.kbxmlc.kbxmId };
      try {
        let res = await this.$api.getPbbfcsByKbxmId(para);
        if (res.status == 200) {
          this.rules = res.data.data;
          this.showRules = true;
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async math() {
      try {
        this.waitLoading = true;
        // 根据列表接口中返回的newOrOld来判断调用新旧计算接口
        let interFaceObj = {
          0: "calculateCommercialBidScore",
          1: "calculateCommercialBidScoreNew",
        };
        let res = await this.$api[interFaceObj[this.newOrOld]]({
          djlcId: this.djlcId,
        });
        if (res.status == 200) {
          this.$message({ type: "success", message: "操作成功！" });
          this.getData();
        } else {
          this.$message({ type: "error", message: res.message });
        }
        this.waitLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * 一键不通过
     * @returns {Promise<void>}
     */
    async oneKeyNoPass() {
      try {
        this.waitLoading = true;
        let res = await this.$api.oneKeyNoPass({ djlcId: this.djlcId });
        if (res.status === 200) {
          this.$message({ type: "success", message: "操作成功！" });
          this.getData();
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async lookJjgg() {
      const res = await this.$api.noticeView();
      let blob = new Blob([res.data], {
        type: "application/pdf",
      });
      let url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    },
    async submitRemark() {
      console.log(this.complianceReview);
      if (!this.complianceReview.bz || this.complianceReview.bz == "") {
        this.$message({
          type: "warning",
          message: "请填写备注",
        });
      } else {
        try {
          let para = {
            djlcId: this.djlcId,
            jgdm: this.complianceReview.companyCode,
            zgsczt: this.complianceReview.complianceReview,
            bz: this.complianceReview.bz,
          };
          this.waitLoading = true;
          let res = await this.$api.saveComplianceReview(para);
          this.waitLoading = false;
          if (res.status == 200) {
            this.handleOk();
          } else {
            this.$message({ type: "error", message: res.message });
          }
        } catch (err) {
          this.waitLoading = false;
          console.log(err);
        }
        this.dialogVisible = false;
      }
    },
    getData() {
      let para = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
      };
      this.waitLoading = true;
      this.$api
        .getListInfoByKbxmId(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.waitLoading = false;
            this.kbxmlc = res.data.data.kbxmlc;
            // 新逻辑
            this.unit = res.data.data.unit;
            this.hasTenderFile = res.data.data.hasTenderFile;
            this.tableData = res.data.data.page.list || [];
            this.total = res.data.data.page.total || 0;
            this.parameterExtractionResults =
              res.data.data.parameterExtractionResults || [];
            // 对中间值进行排序 并预设中间值的取值键名
            this.exhibitionList = (res.data.data.exhibition || [])
              .sort((a, b) => a.pxh - b.pxh)
              .map((item, index) => {
                return {
                  ...item,
                  prop: `exhibition${index}`,
                };
              });
            this.tableData.forEach((el) => {
              if (el.complianceReview === "0") {
                el.complianceReview = "";
                // 如果数据列表中 exhibition字段存在且不为空 则按照预设键名新增键并赋值
              }
              if (el?.exhibition) {
                el.exhibition.split(",").forEach((item, index) => {
                  el[`exhibition${index}`] = item;
                });
              } else {
                // 如果无值 则预设键名 并赋值为空
                this.exhibitionList.forEach((item) => {
                  el[item.prop] = "";
                });
              }
            });
            this.d = res.data.data.d;
            this.adjustmentCoefficient = res.data.data.adjustmentCoefficient;
            this.getComplianceReviewFlag();
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {
          this.waitLoading = false;
        });
    },
    /**
     * 中间值排序
     * @param exhibition
     */
    transformData(exhibition) {
      if (!exhibition || !exhibition.length) return [];
    },
    //查询
    serachData() {
      this.currentPage = 1;
      this.getData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    handleOk() {
      this.isOk = this.tableData.some((el) => {
        return el.complianceReview == "0";
      });
    },
    async saveComplianceReview(row) {
      this.complianceReview = row;
      if (this.complianceReview.complianceReview == "2") {
        this.dialogVisible = true;
      } else {
        try {
          let para = {
            djlcId: this.djlcId,
            jgdm: row.companyCode,
            zgsczt: row.complianceReview,
            bz: row.bz,
          };
          this.waitLoading = true;
          let res = await this.$api.saveComplianceReview(para);
          this.waitLoading = false;
          if (res.status == 200) {
            this.handleOk();
          } else {
            this.$message({ type: "error", message: res.message });
          }
        } catch (err) {
          this.waitLoading = false;
          console.log(err);
        }
      }
    },
    nextBtn() {
      this.$confirm(
        "请确认是否提交数据并进入下一步，确认后评审结果不可修改",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let para = {
            flag: this.kbxmlc.ycdz,
          };
          this.$emit("bxNextBtn", para);
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.footer {
  display: flex;
  align-items: center;
}
.box {
  display: flex;
  flex-direction: column;
}
.rules {
  p {
    line-height: 24px;
    margin-bottom: 10px;
  }
  margin-bottom: 30px;
}
::v-deep .small {
  .el-input__inner {
    height: 24px;
    line-height: 24px;
  }
  .el-input__icon {
    line-height: 24px;
  }
}
.red {
  display: flex;
}
</style>
